module.exports = __webpack_public_path__ + "media/lymphoma.eef1247b.wav";